import React from 'react';

import { equipmentTypes } from 'constants/Equipment';
import {
  Button,
  Label,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@cargomatic/ui';
import { Trash } from 'lucide-react';
import FormGrid from './FormGrid';

export default function EquipmentTypeRateConditionField({
  condition,
  onChange,
  onRemove,
}) {
  const { criteria: value } = condition;

  function handleRemove() {
    onRemove(condition);
  }

  function handleChange(criteria) {
    onChange({ ...condition, criteria });
  }
  return (
    <FormGrid>
      <Label className="w-48">Equipment</Label>
      <Select className="flex-1" value={value} onValueChange={handleChange}>
        <SelectTrigger className="">
          <SelectValue placeholder="Equipment Type" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>Equipment</SelectLabel>
            {Object.values(equipmentTypes).map((equipmentType) => (
              <SelectItem value={equipmentType} key={equipmentType}>
                {equipmentType}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <div>
        <Button variant="icon" onClick={handleRemove}>
          <Trash className="w-3.5 h-3.5" />
        </Button>
      </div>
    </FormGrid>
  );
}
